export const network = {
  users: {
    getUserById: "id/:id",

    addAbilitiesToUser: "abilities",

    register: "register",
    guestRegister: "guests/register",

    sendPhoneConfirmation: "phone/confirm/code/send",

    confirmPhoneNumberWithCode: "phone/confirm",

    resendConfCode: "phone/confirm/code/resend",

    confirmRegister: "register/confirm",

    auth: "auth",
    guestAuth: "guests/auth",
    googleAuth: "google/auth",
    googleAuthRedirect: "google/auth/redirect",

    logout: "logout",

    refreshAccessToken: "tokens/refresh",

    getUserByToken: "token/:token",

    getUserSelectedFields: ":id/fields/:userFields/:specFields",

    update: ":id/update",

    updatePassword: "password",

    confirmPassUpdateCode: "password/code/confirm",

    confirmPassUpdate: "password/update/confirm",

    getUserPublicAvatarAndName: ":id/public/avatar-name",

    getUserAvatarAndName: ":id/avatar-name",

    getAvatarsOfSessionMembers: "avatars/session",

    getUserProfileInfoById: ":id/profile/info",

    checkIfUserJoinedAnyCompany: ":id/joined/company",

    getAllNonSpecialistUsers: "non-specialists/:page/:limit",

    createNewGender: "gender",
    getAllGenders: "genders",

    getUserPublicInfoById: ":id/public/profile/info/:language",

    getUserPublicInfoByEmail: "email/:email/public/profile/info/:language",

    getUserPayments: ":id/payments/:page/:limit",

    updateAvatar: ":id/avatar",
    getAvatarUploadUrl: ":id/avatar/upload-url",
    updateAvatarS3: ":id/avatar/s3",
    getAvatarS3SignedUrl: ":id/avatar/s3/signed-url",

    getAvatarStream: "avatar/:id/stream",

    getAvatarStreamByUserId: ":id/avatar/stream",

    fixUserAvatars: "avatars/fix",

    fixScheduleType: "schedule/fix",

    findUserBySearchString: "search/:string/:specialistOnly",

    getUserLastActivityLogs: ":id/activity/logs",

    addFavouriteUser: "favourites",

    removeFavouriteUser: "favourites",

    getUsersFavouritesList: ":id/favourites/:page/:limit",

    checkIfUserWorkedWithSpecialist: "worked/specialist/:specialistUserId",

    checkIfUserIsFavourite: "is-favourite/:id",

    sendEmailConfirmation: "email/confirm/code/send",
    confirmEmailWithCode: "email/confirm",

    /* getUserPublicInfoLatinName:
      ':id/public/profile/info/:language', */

    getUserGeoInfo: "geo/info",

    getFilteredClients: "clients/filtered",

    isTwilioAvailable: "twilio/available",

    connectPhoneNumber: "phone/connect",

    getUsersBookings: ":id/bookings",

    getUsersBookedPackages: ":id/packages/booked",

    getUsersSessionPayments: ":id/sessions/payments/:page/:limit",

    getUsersSessionHistory: ":id/sessions/history",

    getUserSessionsPagination: ":id/sessions/:page/:limit",

    getUsersDialogChats: ":id/dialog-chats/:page/:limit",

    getPinnedDialogChats: ":id/dialog-chats/pinned/:page/:limit",

    getUserNotes: ":id/notes/:page/:limit",

    getUserTodos: ":id/todos/lists/:page/:limit/:sortType/:sortField",

    getCompaniesOfUser: ":id/companies",

    getUserProjects: ":id/:page/:limit",

    getUserPosts: ":id/posts/:page/:limit",

    pwaInstalled: "pwa/installed",

    getBalanceStatistic: "balance/statistic",

    getUserRating: ":id/rating",

    getUserTransactionsHistory: ":id/transactions/:page/:limit",

    generatePracticeConfirmation: ":id/practice-confirm",

    getTotalPracticeHours: ":id/practice-hours",

    getUserSessionInfo: "sessions/:id/own/info",

    saveClientVisitMetadata: "client-visit-metadata",

    getReferralStats: "referral-stats",

    saveReferralLinkClick: ":id/referral-link-click",
  },

  sessions: {
    incomingCall: "incomingCall",
    acceptCall: "acceptCall",

    getMyId: "getMyId",

    allUsers: "allUsers",

    callUser: "callUser",
    callAccepted: "callAccepted",

    cameraDisconnected: "cameraDisconnected",

    joinRoom: "joinRoom",
    onJoinRoom: "onJoinRoom",

    disconnectFromSession: "disconnectFromSession",

    createSession: "",

    getSessionById: ":id",

    bookSession: "bookings/book",
    bookingNotify: "bookingNotify",

    acceptBooking: "bookings/:id/accept",
    bookingAcceptNotify: "bookingAcceptNotify",

    getBookingById: "bookings/:id",

    getAllUserSessions: "all/:id/:startDate/:endDate",

    userActionInSessionChat: "userActionInSessionChat",

    commentSession: ":id/comment",
    editSessionComment: "comment/:id",
    deleteSessionComment: "comment/:id",
    respondToComment: "comment/:id/respond",
    getSessionComments: ":id/comments",

    getPersonalComments: "comments/personal/:page/:limit",

    commentPackage: "packages/:id/comment",

    getSessionVisitDuration: ":id/visit-durations",

    checkIfCanLeaveComment: "can-comment/:commentForId",

    cancelBooking: "bookings/:id/cancel",

    createNewDefaultComment: "comments/default",
    getAllDefaultComments: "comments/all/default/:mainSpecId",

    createSessionPackage: "packages",

    updatePackage: "packages/:id",

    finishPackageVideoUpload: "packages/:id/preview-file",

    uploadPackageFilePartially: "packages/:id/preview-file/partially",

    setFileToPackageSession: "packages/:id/session/preview-file",

    deletePackageSessionFile: "packages/:id/session/preview-file",

    getPackageFiles: "packages/:id/files",

    deletePackage: "packages/:id",

    getPackageById: "getPackageById",

    getBookedPackageById: "packages/booked/:id",

    bookSessionPackage: "packages/book",

    acceptPackageBooking: "package/:id/accept",

    cancelPackageBooking: "package/:id/cancel",

    getAllSessionPayments: "payments/:page/:limit",

    createPackagePromocode: "packages/:id/promocodes",

    getAllPackagePromocodes: "packages/promocodes/all",

    getPackageImageStream: "packages/images/stream/:id",

    getPackageVideoStream: "packages/videos/stream/:id",

    getPackageSessionImageStream: "packages/sessions/images/stream/:id",

    checkIfCanBookPackage: "packages/:id/can-book/:userId",

    initCronForSession: "initCronForSession",

    refundSession: "refund",
    payOutSession: "pay-out",

    getSessionsWaitingForRefund: "refundable/:page/:limit",

    getSessionInfoById: ":id/info",

    getTotalBookingsAmount: "bookings/amount/total",

    allowAudioRecordForSpecialist: ":id/audio-record/allow",

    sendRealTimeSessionRequest: "real-time/book",
    checkIfCanBookRealTimeSession: "real-time/can-book/:userId/:specId",
    acceptRealTimeSessionRequest: "real-time/accept",
    cancelRealTimeSessionRequest: "real-time/cancel",

    getRealTimeBookingById: "bookings/real-time/:id",

    connectSpecialist: "connectSpecialist",

    addConnectedSpecialist: "addConnectedSpecialist",

    disconnectSpecialist: "disconnectSpecialist",

    getUserSessionStats: "statistic/filtered",

    getSessionStatistics: ":id/statistics",

    getSessionPackageStatistics: "packages/:id/statistics",

    getSessionsAvailableFilters: "filters/available",

    getRescheduleRuleForSession: ":id/reschedule/rule/:type",

    cancelSession: ":id/cancel",

    rescheduleSession: ":id/reschedule",

    getUnapprovedPackages: "packages/unapproved/:page/:limit",

    getBookingBarterType: "booking/:id/barter-type",

    updateSessionGoal: ":id/goal",

    getFlexPassSessionComments: "flexpass/comments/:mainSpecName/:limit",

    bookStaticProjectPackage: "packages/static/book",

    getPackageRecommendations: "packages/recommendations/:page/:limit",

    getFilteredSessions: "filtered",

    getSessionInfoForAdmin: ":id/admin-info",
  },

  chat: {
    joinChat: "joinChat",
    onJoinChat: "onJoinChat",

    sendMessage: "sendMessageInChat",
    onMessage: "onMessageInChat",

    reactOnMessage: "reactOnDialogMessage",
    onMessageReacted: "onDialogMessageReacted",

    reactOnSessionMessage: "reactOnSessionMessage",
    onSessionMessageReacted: "onSessionMessageReacted",

    getChat: ":id/chat",

    newMessage: "receiveNewMessage",

    joinDialogChat: "joinDialogChat",

    sendMessageToDialogChat: "sendMessageToDialogChat",
    onDialogMessage: "onDialogMessage",

    newDialogMessage: "newDialogMessage",

    generateDialogVoiceUploadUrl: ":id/messages/voice/signed-url",
    generateDialogFileUploadUrl: ":id/messages/files/upload-url",

    createDialogChat: "",

    getMessageFiles: "chat/message/:id/files",

    getDialogMessagesById: ":id/messages/:page/:limit",

    searchDialogMessages: ":id/messages/search",

    getDialogMessagesAroundMessage: ":id/messages/:messageId/around",

    getDialogChatById: "getDialogChatById",

    getMessageById: "getMessageById",

    markMessagesAsRead: "messages/read",

    addSystemMessageToDialogChat: "addSystemMessageToDialogChat",

    getSessionChatMessages: ":id/chat/messages/:page/:limit",

    getDialogMessageById: "messages/:id",

    editDialogMessage: "messages/:id/edit",

    deleteDialogMessage: "messages/:id/delete",

    pinDialogMessage: "messages/:id/pin",

    unpinDialogMessage: "messages/:id/unpin",

    pinDialogChat: ":id/pin",

    unpinDialogChat: ":id/unpin",

    startTypingInDialogChat: ":id/typing/start",

    stopTypingInDialogChat: ":id/typing/stop",

    getUnreadDialogMessagesLength: "messages/unread/length",

    getMessageFileStream: "messages/files/:id/stream",

    getMessageImages: "messages/:id/images",

    downloadMessageFile: "messages/files/:id/download",

    distributeAdminMessage: "messages/distribute",

    leaveChat: ":id/leave",

    blockDialogChat: ":id/block",

    muteChat: ":id/mute",
  },

  specialists: {
    update: ":id",

    uploadIntroVideo: ":id/intro-video",
    getIntroVideoUploadUrl: ":id/intro-video/upload-url",
    initiateIntroVideoMultipartUpload:
      ":id/intro-video/multipart-upload/initiate",
    generateIntroVideoPartUrl:
      ":id/intro-video/multipart-upload/chunk/generate-url",
    completeIntroVideoMultipartUpload:
      ":id/intro-video/multipart-upload/complete",
    getIntroVideoS3SignedUrl: ":id/intro-video/signed-url",
    uploadIntroVideoToBucket: "intro-video",
    finishUploadIntroVideoToBucket: "intro-video/complete",

    uploadEducationCertificates: ":id/certificates/educations",
    updateEducationCertificate: "certificates/:id/educations",
    removeEducationCertificate: ":id/certificates/educations",

    uploadQualificationCertificates: ":id/certificates/qualifications",
    updateQualificationCertificate: "certificates/:id/qualifications",
    removeQualificationCertificate: ":id/certificates/qualifications",

    uploadFederationCertificates: ":id/certificates/federations",
    updateFederationCertificate: "certificates/:id/federations",
    removeFederationCertificate: ":id/certificates/federations",

    getCertificateFileUploadUrl: ":id/certificates/files/upload-url",

    getProviderEvidenceUploadUrl: ":id/provider-evidence/files/upload-url",
    getProviderEvidenceFileSignedUrl: ":id/provider-evidence/files/signed-url",

    uploadAppreciationCertificates: ":id/certificates/appreciations",
    updateAppreciationCertificate: "certificates/:id/appreciations",
    removeAppreciationCertificate: ":id/certificates/appreciations",

    getSpecialistById: "id/:id",

    getSpecialistIntroVideo: ":id/intro-video/:videoId",

    getEducationCertificates: ":id/certificates/educations/:page/:limit",
    getEducationPublicCertificates:
      ":id/public/certificates/educations/:page/:limit",

    getQualificationCertificates:
      ":id/certificates/qualifications/:page/:limit",
    getQualificationPublicCertificates:
      ":id/public/certificates/qualifications/:page/:limit",

    getFederationCertificates: ":id/certificates/federations/:page/:limit",
    getFederationPublicCertificates:
      ":id/public/certificates/federations/:page/:limit",
    getAppreciationCertificates: ":id/certificates/appreciations/:page/:limit",
    getAppreciationPublicCertificates:
      ":id/public/certificates/appreciations/:page/:limit",

    getRecommendedSpecialists: "recommended",

    getFilteredSpecialists: "filtered",

    getFilterAvailableParams: "filters/params",

    createMainSpecialization: "main-specs",

    createSubSpecialization: "sub-specs",

    getMainSpecializations: "main-specs",

    getSubSpecializations: "main-specs/:ids/sub-specs",

    getAvailableParams: "params",

    getSpecialistFreeTime: ":userId/:id/free-time/:language",

    getAllSpecialists: "all/:page/:limit",

    getNonVerifiedSpecialists: "non-verified/:page/:limit",

    inviteSpecialistToApp: "invite",

    bulkInviteSpecialistToApp: "invite/bulk",

    getProfileChangeDiff: ":id/profile-diff",

    getAllSpecialzations: "specializations/all",

    createSpecialistTag: "tags",

    changeSpecialistTag: "tags",

    deleteSpecialistTag: "tags",

    addTagsToSpecialist: ":id/tags",

    removeTagsFromSpecialist: ":id/tags",

    getSpecialistTags: "tags/query",

    getEducationCertificateStream: "certificates/educations/stream/:id",
    getQualificationCertificateStream: "certificates/qualifications/stream/:id",
    getFederationCertificateStream: "certificates/federations/stream/:id",
    getAppreciationCertificateStream: "certificates/appreciations/stream/:id",
    getFederationBadgeStream: "certificates/federations/badges/stream/:id",

    addNewSpecialistProfileToUser: ":id/profile",

    createFederationBadge: "federations/badges",
    getFederationBadgeUploadUrl: "federations/badges/upload-url",
    createEducation: "educations",
    createFederation: "federations",
    createQualification: "qualifications",

    mergeEducations: "educations/merge",
    mergeFederations: "federations/merge",
    mergeQualifications: "qualifications/merge",

    updateFederationBadge: "federations/badges",
    updateEducation: "educations/update",
    updateFederation: "federations/update",
    updateQualification: "qualifications/update",

    getFederationBadges: "federations/badges/:specializationId",
    getEducations: "educations/:specializationId",
    getFederations: "federations/:specializationId",
    getQualifications: "qualifications/:specializationId",

    getAllSpecialistBadges: ":id/federations/badges",
    getAllSpecialistUserBadges: "users/:id/federations/badges",

    getAllSpecialistLevels: "levels",

    createEducationCourse: "education/course",
    createEducationAccreditation: "education/accreditation",

    getEducationCourses: "educations/courses/query",
    getEducationAccreditations: "educations/accreditations/query",

    updateEducationCourse: "educations/courses",
    updateEducationAccreditation: "educations/accreditations",

    createTaxCategory: "tax-categories",
    updateTaxCategory: ":id/tax-categories",
    deleteTaxCategory: "tax-categories",
    getTaxCategories: "tax-categories",
    setSpecialistTaxCategory: "tax-categories",

    getAllEducations: "educations/query",
    getAllEducationCourses: "educations/courses/query",
    getAllEducationAccreditations: "educations/accreditations/query",
    getAllFederations: "federations/query",
    getAllQualifications: "qualifications/query",

    getSpecialistServicesConfig: ":id/services-configs",

    getSpecialistPricing: ":id/pricing",

    addNextLevelPriceRotation: "levels/price-rotations/next",
    getNextPriceRotation: "levels/price-rotations/next",
    getCurrentPriceRotation: "levels/price-rotations/current",
    getPriceRotationFile: "levels/price-rotations/file/:id",

    getSpecialistsComments: ":id/comments/:page/:limit",
    getSpecialistsSessionsAmount: ":id/sessions/amount",

    getSpecialistSessionPackages: ":id/sessions/packages",

    getSpecialistSessionPackageById: "sessions/packages/:id",

    getGeneralPackagesInfo: ":id/packages/stats",

    getProfileFillPercentage: ":id/profile/fill-percent",

    getSpecialistRecommendPackage: ":id/recommend-package",

    getMinPricePerMinute: "min-price/minute/:mainSpecId/:levelId",
  },

  stripe: {
    createPayment: "payment",

    createPaymentForSession: "session/payment",

    createPaymentForSubscription: "subscription/payment",

    confirmPaymentSucceeded: "confirmPaymentSucceeded",

    confirmSubscriptionSucceeded: "confirmSubscriptionSucceeded",

    cancelSubscription: "cancelSubscription",

    subscriptionRenewalEvent: "subscriptionRenewalEvent",

    getAllPayments: "payments/:page/:limit",

    createDepositPromocode: "deposits/promocodes",

    getAllDepositPromocodes: "deposits/promocodes",

    handleStripeWebhook: "webhooks/handle",

    payDraftInvoice: "payDraftInvoice",

    createPaymentForFlexPass: "flex-pass/payment",

    createCheckoutPageForFlexPass: "flex-pass/checkout-page",

    createPaymentForWebinar: "webinar/payment",

    getCheckoutInfo: "checkout/:id/info",

    createPaymentForCourse: "course/payment",

    createPaymentForPublication: "publication/payment",

    createPaymentForHub: "hub/payment",
  },

  notes: {
    createNote: "",

    update: ":id",

    deleteNote: ":id",

    getNoteById: "getNoteById",
  },

  quiz: {
    createQuiz: "create",
    updateQuiz: ":id",
    deleteQuiz: ":id",
    getQuizById: ":id",
    cloneQuiz: ":id/clone",
    moveProjectQuiz: ":id/projects/:projectId/move",
    getQuizes: "list",
    createFeedbackQuiz: "feedback",
    cloneFeedbackQuiz: "feedback/templates/:id/clone",
    getFeedbackAssignments: "feedback/assignments",
    getFeedbackResults: "feedback/:id/results",
    cancelFeedbackQuiz: "feedback/:id",
    submitQuizAttempt: ":id/attempts",
    getQuizAttempts: "attempts/list",
    getNearestProjectQuiz: "nearest/projects/:id",
    getQuizStatistics: ":id/statistics",
  },

  todos: {
    createTodo: "lists/:id/todos",

    updateTodoList: "lists/:id",
    update: "lists/:id/todos",

    deleteTodoList: "lists/:id",
    deleteTodo: "lists/:id/todos",

    createTodoList: "lists",

    getTodoById: "getTodoById",

    getTodoListById: "getTodoListById",

    createTodoStatus: "statuses",
  },

  notifies: {
    createNotify: "",

    joinNotifyChannel: "joinNotifyChannel",

    sendNotify: "sendNotify",

    sendPassChangeConfirmation: "sendPassChangeConfirmation",
    sendRegisterConfirmation: "sendRegisterConfirmation",

    getUnreadNotifies: "unread/user/:id",

    markNotifyAsRead: "read",

    getNotifyById: "getNotifyById",

    sendInviteToCompany: "sendInviteToCompany",

    sendInviteToProject: "sendInviteToProject",

    emailAboutSessionCancellation: "emailAboutSessionCancellation",

    emailAboutPackageCancellation: "emailAboutPackageCancellation",

    emailAboutCompanyEvent: "emailAboutCompanyEvent",

    emailAboutProjectKick: "emailAboutProjectKick",

    sendInviteToApp: "sendInviteToApp",

    emailAboutIncommingBooking: "emailAboutIncommingBooking",

    emailHourBeforeSession: "emailHourBeforeSession",

    emailAboutPackageBooking: "emailAboutPackageBooking",

    sendMobileNotify: "mobile",

    emailAboutSubscriptionDeactivated: "emailAboutSubscriptionDeactivated",

    sendEmailConfirmationCode: "sendEmailConfirmationCode",

    sendNotifyAboutProfileAbandon: "sendNotifyAboutProfileAbandon",

    saveWebPushSubscription: "web-push/subscription",

    saveFcmToken: "fcm/token",

    getAllNotifies: "all/:page/:limit",

    recommendedSessionPackages: "Session packages recommended for you",
  },

  companies: {
    createCompany: "",

    update: ":id",

    uploadCompanyLogo: ":id/logo",
    getCompanyLogoUploadUrl: ":id/logo/upload-url",
    uploadCompanyLogoS3: ":id/logo/s3",
    getCompanyLogoS3SignedUrl: ":id/logo/s3/signed-url",

    getLogoStream: "logo/:id/stream",

    deleteCompany: ":id",

    getCompanyById: ":id",

    getCompanyParticipants: ":id/participants/:page/:limit",

    getCompanyStatistic: ":id/stats",

    inviteUserToCompany: ":id/invite",

    inviteBulkUsersToCompany: ":id/invite/bulk",

    inviteEmployeesToCompany: ":id/employees/invite",

    addCompanyOrganizationValue: ":id/organization/:category",

    renameCompanyOrganizationValue: ":id/organization/:category",

    deleteCompanyOrganizationValue: ":id/organization/:category",

    updateCompanyEmployeeProfile: ":id/employees/:employeeId/organization",

    joinCompany: "join",

    rejectCompanyInvitation: "invitations/reject",

    getCompanySessions: ":id/sessions",

    getCompanyProjects: ":id/projects",

    removeUserFromCompany: ":id/users/remove",

    changeCompanyUserRole: ":id/users/roles",

    getAllCompanies: ":page/:limit",

    generateEntryCodeWithoutEmail: ":id/entry-code/generate",

    getCompanySpecialists: ":id/specialists/all",

    getPersonalCompaniesWithRoles: "personal/member-of/all",
  },

  projects: {
    createProject: "",

    update: ":id",

    deleteProject: ":id",

    inviteUserToProject: ":id/invite",

    addSpecialistsToProject: ":id/specialists/add",

    inviteTeamMembers: ":id/team/invite",

    acceptTeamInvitation: "team/invitations/:id/accept",

    declineTeamInvitation: "team/invitations/:id/decline",

    removeTeamMember: ":id/team/remove",

    updateTeamMemberRoles: ":id/team/roles",

    getTeamInvitationById: "team/invitations/:id",

    getTeamInvitationHistory: ":id/team/invitations/history",

    joinProject: "private/join",

    rejectJoinInvitation: "private/join/reject",

    joinNonPrivateProject: "public/join",

    getProjectById: ":id",

    removeUserFromProject: ":id/users/remove",

    getProjectParticipants: ":id/participants",

    getProjectVideoStream: "video/:id/stream",

    getFilteredProjectSpecialists: "specialists/filtered",

    getAvailableSessionsInProject: ":id/sessions/stats",

    uploadVideoToProject: "video",
    getProjectVideoUploadUrl: ":id/video/upload-url",
    initiateProjectVideoMultipartUpload: ":id/video/multipart-upload/initiate",
    generateProjectVideoPartUrl:
      ":id/video/multipart-upload/chunk/generate-url",
    completeProjectVideoMultipartUpload: ":id/video/multipart-upload/complete",
    getProjectVideoS3SignedUrl: ":id/video/signed-url",

    deleteVideoFromProject: "video",

    getMyProjectsWithoutPackage: "no-packages/:specId",

    getProjectPackageOfSpecialist: ":id/packages/:specId",

    switchInvitationWithLink: "link/switch",

    addProjectTags: ":id/tags",

    leaveProject: ":id/leave",

    pauseProjectParticipation: ":id/pause",

    unpauseProjectParticipation: ":id/unpause",

    getProjectSessionComments: ":id/comments/:limit",

    getProjectActivityLogs: ":id/activity-logs/:page/:limit",

    getProjectOverviewStatistics: ":id/statistics",

    getProjectStatisticsV2: ":id/statistics/v2",

    getProjectEmployeesProgress: ":id/statistics/employees",

    getProjectEmployeeProgress: ":id/statistics/employees/:employeeId",
  },

  google: {
    generateCode: "auth/url",
    redirect: "redirect",

    insertNewEvent: "insertNewEvent",

    checkGoogleRefreshToken: "token/refresh",

    getUserCalendarList: "calendars/:id",

    testCalendarsAccess: "calendars/access/:id",

    revokeConnection: "calendars/revoke/:id",
  },

  stats: {
    getAdminDashboardStats: "admin/dashboard",

    getVerifiedSpecStatistic: "verified-specs",

    saveErrorLog: "error",

    getServicesStatus: "services/statuses",

    getUniversalFlexPassStatistic: "flexpass/universal/:mainSpec/:language",

    downloadClientMetadataTable: "client-metadata/download",

    downloadSessionMetadataTable: "session-metadata/download",
  },

  posts: {
    createPost: "",

    createAdminPost: "admin",

    deletePost: ":id",

    getPostById: "getPostById",

    getPostCommentById: "getPostCommentById",

    updatePost: ":id",

    updatePostFiles: ":id/files",

    removePostFile: ":id/files",

    getPostsFeed: ":id/:type/:page/:limit",

    likePost: "like",

    unlikePost: "unlike",

    commentPost: "comment",

    updateComment: "comments/:id",

    removeComment: "comments/:id",

    likeComment: "comments/like",

    unlikeComment: "comments/unlike",

    getPostFiles: ":id/files",

    getPostImageStream: "files/images/:id",

    getPostVideoStream: "files/videos/:id",

    getUnverifiedPosts: "unverified/:page/:limit",
  },

  socials: {
    followUser: "follow",

    unfollowUser: "unfollow",

    getFollowers: "followers/:page/:limit",

    getFollowings: "followings/:page/:limit",

    checkIfFollowed: "followed/:id",
  },

  subscriptions: {
    createSubscription: "",
    updateSubscription: "",
    deleteSubscription: "",
    getAllSubscriptions: "query",
    getActiveSubscribersAmount: ":id/users/active/amount",
    getMyActiveSubscription: "current",
    getMySubscriptionHistory: "history",
    createSubscriptionShortInfo: ":id/short-info",
    createSubscriptionFeatures: "short-info/:id/features",
    getSubscriptionIconStream: "icons/:id/stream",
    updateSubscriptionShortInfo: "short-info",
    updateSubscriptionFeature: "short-info/features",
    deleteSubscriptionShortInfo: "short-info",
    deleteSubscriptionFeature: "short-info/features",
    updateSubscriptionShortInfoIcon: "short-info/icon",
    updateSubscriptionFeatureIcon: "short-info/features/icon",
    getTotalSubscriptionsAmount: "amount",
  },

  treeQuizes: {
    createTreeQuiz: "",
    addTreeQuizFirstQuestion: "questions/first",
    getTreeQuiz: "id/:id",
    createTreeQuizQuestion: "questions",
    addAnswerToTreeQuestion: "questions/answers",
    removeAnswerFromTreeQuestion: "questions/answers",
    getTreeQuizQuestion: "questions/:id",
    createTreeQuizAnswer: "questions/answers",
    changeTreeQuizAnswer: "questions/answers",
    getTreeQuizAnswer: "questions/answers/:id",
    saveTreeQuizAnswerResult: "answer",
    cancelTreeQuizAnswerResult: "answer",
    createTreeQuizResult: "results",
    addAnswerResultToTreeQuizResult: "results/add/answer",
    getTreeQuizResult: "results",
    getRecommendationsFromTreeQuiz: "recommendations/:page/:limit",
    getRecommendationQuiz: "recommendation",
    buildQuizes: "build",
    buildTestSpecialists: "speciallists/build",
  },

  twilio: {
    sendRegisterVerificationCode: "sendRegisterVerificationCode",
    verifyRegisterConfirmationCode: "verifyRegisterConfirmationCode",

    getIceServers: "twilio/ice-servers",
  },

  deployFixes: {
    specialistIdToSpecialistIds: "specialistIdToSpecialistIds",

    specialistUsersToSpecialists: "specialistUsersToSpecialists",

    addLatinNameToUsers: "addLatinNameToUsers",

    scheduleReworkFix: "scheduleReworkFix",

    fixNamesMultilanguage: "fixNamesMultilanguage",
    fixIntroVideosMultilanguage: "fixIntroVideosMultilanguage",

    addServicesConfigToSpecialists: "addServicesConfigToSpecialists",

    addShortIdToUsers: "addShortIdToUsers",
    addShortIdToProjects: "addShortIdToProjects",
    addShortIdToPackages: "addShortIdToPackages",
  },

  recordings: {
    approveRecording: "approve/:id",

    callAudioRecorder: "callAudioRecorder",

    getAudioRecordStream: "stream/:id",

    getSessionRecordingInfo: "info/:id",

    recordStarted: "recordStarted",
    recordStopped: "recordStopped",
    recordInitialized: "recordInitialized",
    recordCancel: "recordCancel",

    getSessionRecordings: "records/:id",
    getWebinarRecordings: "webinar/records/:id",

    getSessionTranscriptionCsv: "transcriptions/csv/:id",

    createSessionTranscription: "transcriptions/:id",

    deleteSessionRecordings: "sessions/:id",

    saveRecordViewLog: "view-log",

    getRecordViewStats: "view-stats",
  },

  databasePatches: {
    importEducations: "educations",
    importFederations: "federations",
    importQualifications: "qualifications",
    moveLanguagesToSpecs: "languages",
    convertSpecPrices: "prices",
    addSpecialistToSessionComments: "comments",

    syncSpecializationTaxonomyFromCsv: "specializations",
    syncSpecialistTagsFromCsv: "specialist-tags",
    syncSpecialistLevelsForNewDirections: "specialist-levels",
    syncTreeQuizTaxonomyFromCsv: "tree-quiz",
    backfillProjectMembershipPeriods: "project-memberships",
    backfillCourseLectureTypes: "course-lecture-types",

    syncEducationsFromCsv: "educations/csv",
    syncFederationsFromCsv: "federations/csv",
    syncQualificationsFromCsv: "qualifications/csv",
  },

  socketEvents: {
    incomingBooking: "incomingBooking",
    canceledBooking: "canceledBooking",
    acceptedBooking: "acceptedBooking",
  },

  logger: {
    getAllLogs: "",
  },

  livekit: {
    getLiveKitToken: "token/:roomName",
    startLiveKitAudioRecording: "audio/start/:roomName",
    stopLiveKitAudioRecording: "audio/stop/:roomName",

    generateTurnExpiryCredintials: "room/:id/turn/credentials",

    webhook: "webhook",
  },

  payout: {
    saveBankPayoutInfo: "bank/payout-info",
    getBankPayoutInfo: "bank/payout-info",
    createBankPayRequest: "bank/pay-request",
    getBankPayRequests: "bank/pay-requests/:page/:limit",
    getMyBankPayRequests: "bank/pay-requests/personal/:page/:limit",
    cancelBankPayRequest: "bank/pay-request/cancel",
    changeBankPayRequestStatus: "bank/pay-request/status",
    changePayoneerPayRequestStatus: "payoneer/pay-request/status",
  },

  payoneer: {
    savePayoneerPayoutInfo: "payoneer/payout-info",
    getPayoneerPayoutInfo: "payoneer/payout-info",
    createPayoneerPayRequest: "payoneer/pay-request",
    getPayoneerPayRequests: "payoneer/pay-requests/:page/:limit",
    getMyPayoneerPayRequests: "payoneer/pay-requests/personal/:page/:limit",
    cancelPayoneerPayRequest: "payoneer/pay-request/cancel",
    changePayoneerPayRequestStatus: "payoneer/pay-request/status",
  },

  flexpass: {
    createFlexPassSubscription: "create",

    updateFlexPassSubscription: ":id",

    deleteFlexPassSubscription: ":id",

    getFilteredFlexPassSubscriptions: "get/filtered",

    inviteSpecToFlexPassSubscription: ":id/invite",

    getPersonalFlexPassSubscriptions: "personal",

    getFilteredSubscriptionSpecialists: "specialists/filtered",

    joinFlexPassSpecialist: "join",

    kickFlexPassSpecialist: ":id/specialists/:specId/kick",

    getFlexPassParticipants: ":id/participants",

    purchaseFlexPassSubscription: ":id/purchase",

    getFlexPassSubscriptionById: ":id",

    getSpecialistFlexPassSubscriptions: "specialist/:id",

    getSpecialistsFitForFlexPass: ":id/specialists/fit",

    getPersonalClientFlexPassById: "personal/specific",

    getUnivarsalFlexPassesInfo: "universal/info/:mainSpec/:language",

    purchaseFlexPassWithoutRegister: ":id/purchase/guest",
  },

  promocodes: {
    createDiscountPromocode: "create",

    getDiscountPromocodes: "get/filtered",

    updateDiscountPromocode: ":id",

    deleteDiscountPromocode: ":id",

    getDiscountPromocodeByCode: "code/:code",

    getProductPromocodeByCode: "product/code/:code",
  },

  socketIo: {
    emitEvent: "emit",

    balanceChanged: "balanceChanged",

    webinarChatMessage: "webinarChatMessage",

    sessionIsEnding: "sessionIsEnding", // payload: {minutesLeft: number}

    sessionEnded: "sessionEnded",

    newCourseOffers: "newCourseOffers",

    messagesRead: "messagesRead",

    dialogMessageEdited: "dialogMessageEdited",

    dialogMessageDeleted: "dialogMessageDeleted",

    dialogMessageMentioned: "dialogMessageMentioned",

    dialogMessagePinned: "dialogMessagePinned",

    dialogMessageUnpinned: "dialogMessageUnpinned",

    dialogChatTypingStarted: "dialogChatTypingStarted",

    dialogChatTypingStopped: "dialogChatTypingStopped",

    clientWasLate: "clientWasLate",
    specialistWasLate: "specialistWasLate",
  },

  clientDashboard: {
    getDashboardBlocks: "blocks/weights",
  },

  webinar: {
    getWebinarById: ":id",

    create: "create",

    update: ":id",

    delete: ":id",

    generateS3uploadUrlForFile: ":id/files/signed-url",

    addFileToWebinar: ":id/files",

    initiateFileMultipartUpload: ":id/files/multipart-upload/initiate",

    generateFilePartUrl: "files/multipart-upload/chunk/generate-url",

    completeFileMultipartUpload: ":id/files/multipart-upload/complete",

    getSpecialistWebinars: "specialist/:id/:page/:limit",

    getWebinarFileSignedUrl: "files/filepath",

    getAllWebinarFileSignedUrls: ":id/files/all",

    deleteWebinarFile: ":id/files",

    getPersonalCertificateSignedUrl: ":id/certificate/personal",

    getFilteredWebinars: "filtered/:page/:limit",

    purchaseWebinar: ":id/purchase",

    purchaseWebinarRecording: ":id/recording/purchase",

    getWebinarChat: ":id/chat",

    getWebinarAuthorsRecommendations: ":id/recommendations/:page/:limit",

    getWebinarTopicsAttendance: ":id/topics/attendance",

    getPersonalCertificateAvailability: ":id/certificate/personal/availability",

    cloneWebinar: ":id/clone",

    checkIfCanLeaveComment: ":id/can-comment",

    commentWebinar: ":id/comment",

    editWebinarComment: "comment/:id",

    deleteWebinarComment: "comment/:id",

    getWebinarComments: ":id/comments/:page/:limit",

    getAllDefaultComments: "comments/all/default",

    getWebinarStatistics: ":id/statistics",

    getWebinarOwnerStatistics: "statistics/general",

    savePersonalCertificateLog: ":id/certificate/personal/:action",

    getSpecialistWebinarsForOffer: "specialist/:id/offers-fit",

    getEducationalHubWebinars: "educational-hub/:id/:page/:limit",

    //socket events
    connectToWebinarRoom: "connectToWebinarRoom",
    connectedSuccessfully: "connectedSuccessfully",

    raiseHand: "raiseHand",
    handRaised: "handRaised",
    unraiseHandByAdmin: "unraiseHandByAdmin",
    allHandsUnraised: "allHandsUnraised",

    sendEmoji: "sendEmoji",
    emojiSent: "emojiSent",

    muteMicrophone: "muteMicrophone",
    muteAllMicrophonesByAdmin: "muteAllMicrophonesByAdmin",
    microphoneMuted: "microphoneMuted",

    muteVideo: "muteVideo",
    muteAllVideosByAdmin: "muteAllVideosByAdmin",
    videoMuted: "videoMuted",

    muteChat: "muteChat",
    muteAllChatsByAdmin: "muteAllChatsByAdmin",
    chatMuted: "chatMuted",

    shiftAgenda: "shiftAgenda",
    agendaChanged: "agendaChanged",

    getRoomUsers: "getRoomUsers",
    roomUsersRes: "roomUsersRes",

    sendMessage: "sendWebinarChatMessage",
    onMessage: "onWebinarChatMessage",
    newMessage: "newWebinarChatMessage",

    startWebinar: "startWebinar",
    webinarStarted: "webinarStarted",

    endWebinar: "endWebinar",
    webinarEnded: "webinarEnded",

    kickUserFromWebinar: "kickUserFromWebinar",
    userKickedFromWebinar: "userKickedFromWebinar",

    showOffers: "showOffers",
    offersShown: "offersShown",

    interestInOffer: "interestInOffer",
    offerInterestAccepted: "offerInterestAccepted",

    reactOnMessage: "reactOnWebinarMessage",
    messageReacted: "webinarMessageReacted",
  },

  courses: {
    getCourseById: ":id",

    create: "create",

    update: ":id",

    delete: ":id",

    cloneCourse: ":id/clone",

    generateS3uploadUrlForFile: ":id/files/signed-url",

    addFileToCourse: ":id/files",

    initiateFileMultipartUpload: ":id/files/multipart-upload/initiate",

    generateFilePartUrl: "files/multipart-upload/chunk/generate-url",

    completeFileMultipartUpload: ":id/files/multipart-upload/complete",

    getCourseFileSignedUrl: "files/filepath",

    deleteCourseFile: ":id/files",

    getPersonalCertificateSignedUrl: ":id/certificate/personal",

    getSpecialistCourses: "specialist/:id/:page/:limit",

    getFilteredCourses: "filtered/:page/:limit",

    purchaseCourse: ":id/purchase",

    getAllCourseFileSignedUrls: ":id/files/all",

    generateS3uploadUrlForHomeworkFile: ":id/homework/files/signed-url",

    addFileToHomework: "homework/:id/files",

    deleteHomeworkFiles: "homework/:id/files",

    createHomework: ":id/homework",

    updateHomework: "homework/:id",

    getCourseHomeworkById: "homework/:id",

    getPersonalCourseHomeworks: ":id/homeworks",

    getHomeworkFileSignedUrls: "homework/:id/files/all",

    markLectureAsFinished: ":id/lectures/:lectureId/finish",

    getReadyToReviewHomeworks: "homeworks/ready-to-review",

    getPersonalCertificateAvailability: ":id/certificate/personal/availability",

    checkIfCanLeaveComment: ":id/can-comment",

    commentCourse: ":id/comment",

    editCourseComment: "comment/:id",

    deleteCourseComment: "comment/:id",

    getCourseComments: ":id/comments/:page/:limit",

    getAllDefaultComments: "comments/all/default",

    getCourseStatistics: ":id/statistics",

    getCourseOwnerStatistics: "statistics/general",

    getPersonalCourseProgress: ":id/progress",

    getCourseAuthorsRecommendations: ":id/recommendations/:page/:limit",

    savePersonalCertificateLog: ":id/certificate/personal/:action",

    getSpecialistCoursesForOffer: "specialist/:id/offers-fit",

    getEducationalHubCourses: "educational-hub/:id/:page/:limit",
  },

  publications: {
    getPublicationById: ":id",

    create: "create",

    update: ":id",

    getFilteredPublications: "filtered/:page/:limit",

    acquireFree: ":id/acquire-free",

    purchase: ":id/purchase",

    rate: ":id/rating",

    statistics: ":id/statistics",

    generateUploadUrl: ":id/files/upload-url",

    initiateMultipartUpload: ":id/files/multipart-upload/initiate",

    generateFilePartUrl: ":id/files/multipart-upload/part-url",

    completeMultipartUpload: ":id/files/multipart-upload/complete",

    updateFiles: ":id/files",

    getDraftFiles: ":id/files",

    getFiles: ":id/content",

    getFileAccess: ":id/content/:fileId",
  },

  educationalHub: {
    createHub: "create",
    createHubForUserByAdmin: "create/admin",
    getHub: ":id",
    getHubBySubdomain: "subdomain/:subdomain",
    getHubsByOwner: "owner/:userId",
    getPersonalHubs: "personal/working",
    getFilteredHubs: "filtered/all",
    updateHub: ":id",
    deleteHub: ":id",
    getUnapprovedHubs: "unapproved/:page/:limit",
    getHubActivityLogs: ":id/logs/:page/:limit",
    getHubBasicStatistic: ":id/statistic/basic",
    getUserAccessRules: ":id/user/:userId/access-rules",
    payForHub: ":id/pay",

    getDefaultAssessmentScale: "assessment-scales/default",
    createAssessmentScale: ":id/assessment-scales",
    listAssessmentScales: ":id/assessment-scales",
    getAssessmentScale: ":id/assessment-scales/:scaleId",
    updateAssessmentScale: ":id/assessment-scales/:scaleId",
    deleteAssessmentScale: ":id/assessment-scales/:scaleId",
    getGradebook: ":id/gradebook/query",
    queryReport: ":id/reports/query",
    exportReport: ":id/reports/export/:format",
    createReportPreset: ":id/reports/presets",
    listReportPresets: ":id/reports/presets",
    getReportPreset: ":id/reports/presets/:presetId",
    updateReportPreset: ":id/reports/presets/:presetId",
    deleteReportPreset: ":id/reports/presets/:presetId",
    getSchoolReviews: ":id/reviews/query",
    replyToSchoolReview: ":id/reviews/:reviewId/reply",

    inviteTeamMembers: ":id/team/invite",
    acceptTeamInvitation: "team/invitations/:id/accept",
    declineTeamInvitation: "team/invitations/:id/decline",
    removeTeamMember: ":id/team/remove",
    updateTeamMemberRoles: ":id/team/roles",
    getHubTeamInvitationById: "team/invitations/:id",
    getHubTeamInvitationHistory: ":id/team/invitations/history",

    createHubProgram: ":id/programs",
    getHubProgram: "programs/:id",
    getProgramsByHub: ":id/programs",
    updateHubProgram: "programs/:id",
    deleteHubProgram: "programs/:id",
    getProgramStatistics: "programs/:id/statistics",

    createGroup: "courses/:id/groups",
    getGroup: "groups/:id",
    getGroupsByProgram: "courses/:id/groups",
    updateGroup: "groups/:id",
    configureGroupSelfRegistration: "groups/:id/self-registration",
    publishGroup: "groups/:id/publish",
    duplicateGroup: "groups/:id/duplicate",
    deleteGroup: "groups/:id",
    getOwnGroups: "groups/own/all",
    createProgramPackage: "programs/:id/packages",
    updateProgramPackage: "programs/packages/:id",
    getProgramPackages: "programs/:id/packages",
    purchaseProgramPackage: "programs/packages/:id/purchase",

    createChapter: "groups/:id/chapters",
    updateChapter: "chapters/:id",
    deleteChapter: "chapters/:id",
    getChaptersByGroup: "groups/:id/chapters",

    createModule: "groups/:id/modules",
    updateModule: "modules/:id",
    deleteModule: "modules/:id",
    getModulesByGroup: "groups/:id/modules",
    reorderModules: "groups/:id/modules/reorder",
    getModuleById: "modules/:id",
    configurePublicPreview: "public-preview/:resourceType/:id",
    getPublicPreview: "public-preview/:token",

    createLiveEvent: "modules/:id/live-event",
    updateLiveEvent: "live-events/:id",
    deleteLiveEvent: "live-events/:id",
    updateLiveEventGroupAssociations: "live-events/:id/groups",
    getHubLiveEventSpecialistAvailability:
      "live-events/:id/specialists/availability",
    requestHubLiveEventSpecialist: "live-events/:id/specialist-requests",
    acceptLiveEventSpecialistRequest:
      "live-events/:id/specialist-requests/:requestId/accept",
    rejectLiveEventSpecialistRequest:
      "live-events/:id/specialist-requests/:requestId/reject",

    createRecordedEvent: "modules/:id/recorded-event",
    updateRecordedEvent: "recorded-events/:id",
    deleteRecordedEvent: "recorded-events/:id",

    inviteParticipants: "groups/:id/participants/invite",
    importParsedParticipants: "groups/:id/participants/import",
    selfRegisterParticipant:
      ":id/programs/:programId/groups/:groupId/self-register",
    acceptParticipantInvitation: "participants/:id/accept",
    updateParticipantStatus: "participants/:id/status",
    getParticipantById: "participants/:id",
    getHubStudentProducts: ":id/students/:studentUserId/products",
    excludeHubStudentFromProducts: ":id/students/:studentUserId/exclude",
    getAcademicLeaveResumeCandidates: "participants/:id/resume-candidates",
    sendAcademicLeaveResumeInvitation: "participants/:id/resume-invitations",

    createBreakoutRooms: "live-events/:id/breakout-rooms",
    updateBreakoutRoom: "breakout-rooms/:id",
    deleteBreakoutRoom: "breakout-rooms/:id",

    generateS3UploadUrlForHubFile: ":id/files/signed-url",
    addFileToHub: ":id/files",
    initiateHubFileMultipartUpload: ":id/files/multipart-upload/initiate",
    generateHubFilePartUrl: "files/multipart-upload/chunk/generate-url",
    completeHubFileMultipartUpload: ":id/files/multipart-upload/complete",
    getHubFileSignedUrl: "files/filepath",
    deleteHubFile: ":id/files",

    generateS3uploadUrlForHomeworkFile: ":id/homework/files/signed-url",
    addFileToHomework: "homework/:id/files",
    deleteHomeworkFiles: "homework/:id/files",
    createHomework: ":id/homework",
    updateHomework: "homework/:id",
    getCourseHomeworkById: "homework/:id",
    getPersonalProgramHomeworks: "programs/:id/homeworks",
    getHomeworkFileSignedUrls: "homework/:id/files/all",
    markModuleAsFinished: ":id/modules/:id/finish",
    getReadyToReviewHomeworks: "homeworks/ready-to-review",

    getHubStudents: ":id/students",
    getGroupParticipantsWithProgress:
      "groups/:id/participants/progress/:page/:limit",
    getGroupParticipantProgress:
      "groups/:id/participants/:participantUserId/progress",
    getHubStudentProfile: ":id/students/:studentUserId/profile",

    submitQuizAttempt: "modules/:id/quiz/attempts",
    getQuizAttempts: "modules/:id/quiz/attempts",
    getQuizAttemptById: "quiz/attempts/:id",
  },
};

export const googleScopes = [
  "https://www.googleapis.com/auth/calendar",
  "https://www.googleapis.com/auth/userinfo.email",
];

export const constants = {
  questionAboutMainSpecialization: "Which specialist would you like?",
  questionAboutSubSpecialization: "Select specialist subspecialty",
  questionAboutGender: "Select preffered gender of specialist",
  coachSubSpecQuestion: "Coach quiz",
  mentorSubSpecQuestion: "Mentor quiz",
  psychologistSubSpecQuestion: "Psyhologist quiz",
  coachSubSpecName: "Coach",
  mentorSubSpecName: "Mentor",
  psychologistSubSpecName: "Psychologist",
};

export const emailTexts = {
  projectKickSubject: "Project kick",
  googleCalendarSubject: "Google Calendar",
  sessionCancelSubject: "Canceled session",
  projectInviteSubject: "Invitation to project",
  companyInviteSubject: "Invitation to company",
  registerConfirmSubject: "Confirm Registration",
  passwordUpdateSubject: "Password update",
  appInviteSubject: "Invite to Talzi!",
  googleCalendarConnectTitle:
    "You have not connected your Google Calendar to Talzi. Please, do this, to see your sessions in your google calendar!",
  incommingBookingSubject: "Session booking",
  incommingPackageBookingSubject: "Session package booking",
  hourBeforeSession: "Incoming session",
  subscription: "Talzi subscription",
  profileAbandoned: "Profile abandoned",
};
